import api from '../api';
import { createWrapperPayload, wrapperConstants } from '../wrapper-api';

export interface RunlifeDashboardData {
  [key: string]: unknown;
}

const withPascalAliases = (basePayload: any) => {
  if (!basePayload || typeof basePayload !== 'object') return basePayload;
  const copy: any = { ...basePayload };

  const fixKey = (camel: string) => {
    const pascal = camel[0].toUpperCase() + camel.slice(1);
    if (camel in copy) {
      if (!(pascal in copy)) copy[pascal] = copy[camel];
      delete copy[camel];
    }
  };

  ['apiApplicationName', 'assetId', 'callType', 'payload'].forEach(fixKey);

  const origUrl = copy.Url ?? copy.URL ?? copy.url;
  delete copy.url;
  delete copy.URL;
  delete copy.Url;
  if (origUrl) copy.Url = origUrl;

  return copy;
};

export const fetchRunlifeDashboardDataService = async (params?: {
  year?: number;
  dateType?: string;
  startDate?: string;
  endDate?: string;
  areaIds?: string[];
  businessUnitIds?: string[];
  fieldIds?: string[];
  wellIds?: string[] | string;
}): Promise<any> => {
  try {
    let endpoint = '/pumpchecker/Home/AnalyticsData';
    const qp: string[] = [];
    if (params?.year !== undefined && params.year !== null) qp.push(`year=${encodeURIComponent(String(params.year))}`);
    if (params?.dateType) qp.push(`FilterByDate=${encodeURIComponent(params.dateType)}`);
    if (params?.startDate) qp.push(`From=${encodeURIComponent(params.startDate)}`);
    if (params?.endDate) qp.push(`To=${encodeURIComponent(params.endDate)}`);
    if (qp.length) endpoint += `?${qp.join('&')}`;

    const requestPayload = createWrapperPayload(
      'GET',
      endpoint,
      undefined,
      false,
      params?.areaIds,
      params?.businessUnitIds,
      params?.fieldIds,
      params?.wellIds,
    );
    const finalPayload = withPascalAliases(requestPayload);

    const resp = await api.post(wrapperConstants.router, finalPayload);
    return resp?.data ?? undefined;
  } catch (err) {
    console.error('[RunlifeService] fetchRunlifeDashboard error', err);
    return undefined;
  }
};

export const fetchInstallationYearsService = async (): Promise<number[]> => {
  try {
    const requestPayload = createWrapperPayload('GET', '/pumpchecker/Lookup/GetInstallationYears');
    const finalPayload = withPascalAliases(requestPayload);

    const resp = await api.post(wrapperConstants.router, finalPayload);
    return Array.isArray(resp?.data) ? resp.data : [];
  } catch (err) {
    console.error('[RunlifeService] fetchInstallationYears error', err);
    return [];
  }
};

export const fetchFilterDatesService = async (): Promise<{ Key: string; Value: string }[]> => {
  try {
    const requestPayload = createWrapperPayload('GET', '/pumpchecker/Lookup/GetFilterDates');
    const finalPayload = withPascalAliases(requestPayload);

    const resp = await api.post(wrapperConstants.router, finalPayload);
    return Array.isArray(resp?.data) ? resp.data : [];
  } catch (err) {
    console.error('[RunlifeService] fetchFilterDates error', err);
    return [];
  }
};

export default {
  fetchRunlifeDashboardDataService,
  fetchInstallationYearsService,
  fetchFilterDatesService,
};
